import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const KEY = 'cookie_consent';

// GA4 runs in Consent Mode v2 (see index.html): cookies only after "Αποδοχή",
// otherwise anonymous cookieless pings that Google uses for modelling.
export default function CookieConsent() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored = null;
    try { stored = localStorage.getItem(KEY); } catch { /* storage blocked */ }
    setVisible(!stored);
  }, []);

  const choose = (value) => {
    try { localStorage.setItem(KEY, value); } catch { /* storage blocked */ }
    window.__setAnalyticsConsent?.(value);
    setVisible(false);
  };

  if (!visible || pathname.startsWith('/admin')) return null;

  return (
    <div role="dialog" aria-live="polite" aria-label="Προτιμήσεις cookies"
      className="fixed inset-x-0 bottom-0 sm:inset-x-4 sm:bottom-4 z-[60] mx-auto max-w-[720px] max-h-[25vh] sm:max-h-none overflow-y-auto rounded-t-card sm:rounded-card bg-warm-black text-cream shadow-card px-4 py-3 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-2.5 sm:gap-4">
      <p className="text-[14px] sm:text-body-s leading-[1.45] sm:leading-[1.6] text-cream/85 flex-1">
        Χρησιμοποιούμε απαραίτητα cookies και, με τη συγκατάθεσή σας, Google Analytics και Microsoft Clarity για στατιστικά, χάρτες κλικ και καταγραφές περιήγησης.{' '}
        <a href="/cookies" className="text-gold-light underline underline-offset-2">Πολιτική Cookies</a>
      </p>
      <div className="flex gap-3 shrink-0">
        <button type="button" onClick={() => choose('denied')}
          className="flex-1 sm:flex-none min-h-[44px] whitespace-nowrap tracking-normal sm:tracking-wider px-3 sm:px-5 py-2.5 rounded-pill border border-cream/30 text-tiny font-semibold uppercase tracking-wider hover:bg-cream/10 transition-colors">
          Μόνο απαραίτητα
        </button>
        <button type="button" onClick={() => choose('granted')}
          className="flex-1 sm:flex-none min-h-[44px] px-4 sm:px-5 py-2.5 rounded-pill bg-gold-light text-warm-black text-tiny font-semibold uppercase tracking-wider hover:bg-gold-bg transition-colors">
          Αποδοχή
        </button>
      </div>
    </div>
  );
}